// src/components/ContactButton.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ContactButton.css';

export default function ContactButton() {
  const navigate = useNavigate();

  const handleContactClick = () => {
    // Marquer qu'on veut scroller en haut pour la page de contact
    sessionStorage.setItem('scrollToTop', 'true');
    
    // Naviguer vers la page de contact
    navigate('/contact');
  };

  return (
    <button
      className="contact-button"
      onClick={handleContactClick}
      aria-label="Contactez-nous"
    >
      Contactez-nous
    </button>
  );
}